import { forNotForData } from "../data/mock";
import { Check, X, Sparkles, ShieldOff } from "lucide-react";

const HighlightText = ({ text, keyword }) => {
  if (!keyword) return text;
  const parts = text.split(keyword);
  if (parts.length < 2) return text;
  return (
    <>
      {parts[0]}
      <span className="text-[#dfddd6] font-semibold">{keyword}</span>
      {parts[1]}
    </>
  );
};

export const ForNotForSection = () => {
  return (
    <section
      className="relative py-28"
      style={{ background: "#252422" }}
    >
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* For You */}
          <div className="bg-[#1a1c1b] border border-[#3f4816]/15 p-8 rounded-sm">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-9 h-9 rounded-md bg-[#3f4816]/15 border border-[#3f4816]/25 flex items-center justify-center">
                <Sparkles size={16} className="text-[#d9fb06]" />
              </div>
              <h3
                className="text-[#dfddd6] font-bold text-lg uppercase tracking-tight"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {forNotForData.forYou.title}
              </h3>
            </div>
            <div className="flex flex-col gap-4">
              {forNotForData.forYou.items.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="flex-shrink-0 mt-0.5 w-6 h-6 rounded bg-[#3f4816]/10 border border-[#3f4816]/20 flex items-center justify-center">
                    <Check size={12} className="text-[#d9fb06]" />
                  </div>
                  <p
                    className="text-[#888680] text-sm leading-relaxed"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    <HighlightText text={item.text} keyword={item.keyword} />
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Not For You */}
          <div className="bg-[#1a1c1b] border border-[#3f4816]/15 p-8 rounded-sm">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-9 h-9 rounded-md bg-[#888680]/8 border border-[#888680]/15 flex items-center justify-center">
                <ShieldOff size={16} className="text-[#888680]/60" />
              </div>
              <h3
                className="text-[#888680]/70 font-bold text-lg uppercase tracking-tight"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {forNotForData.notForYou.title}
              </h3>
            </div>
            <div className="flex flex-col gap-4">
              {forNotForData.notForYou.items.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="flex-shrink-0 mt-0.5 w-6 h-6 rounded bg-[#888680]/5 border border-[#888680]/15 flex items-center justify-center">
                    <X size={12} className="text-[#888680]/50" />
                  </div>
                  <p
                    className="text-[#888680]/60 text-sm leading-relaxed"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    <HighlightText text={item.text} keyword={item.keyword} />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
